import { makeStyles, Theme } from "@material-ui/core/styles";

const useStyles = makeStyles((theme: Theme) => ({
  container: {
    position: "relative",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    width: "100%",
    height: "100vh",
    backgroundColor: theme.palette.background.paper,
  },
  content: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    gap: "40px",
    maxWidth: "600px",
    padding: "40px",
  },
  title: {
    fontSize: "48px",
    fontWeight: 700,
    color: theme.palette.text.primary,
    textAlign: "center",
  },
  subtitle: {
    fontSize: "24px",
    color: theme.palette.text.secondary,
    textAlign: "center",
  },
  link: {
    display: "flex",
    flexDirection: "row",
    marginTop: 12,
    cursor: "pointer",

    "& span": {
      fontSize: 16,
      fontWeight: "bold",
      textDecorationLine: "underline",
      marginLeft: 8,
    },
  },
  modal: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  modalView: {
    position: "relative",
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
    width: 400,
    height: 350,
    backgroundColor: theme.palette.background.paper,
    borderRadius: 8,
    padding: 24,
    outline: "none",
    gap: 24,

    "& > span": {
      fontSize: 20,
      fontWeight: 500,
      textAlign: "center",
      color: theme.palette.text.primary,
    },
  },
  close: {
    position: "absolute",
    top: 16,
    right: 16,
    cursor: "pointer",
    color: theme.palette.text.primary,

    "& > svg": {
      fontSize: 32,
    },
  },
  adminActions: {
    position: "fixed",
    right: 0,
    bottom: 0,
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "space-around",
    height: 130,
  },
  action: {
    width: 42,
    height: 42,
    cursor: "pointer",
  },
}));

export default useStyles;
